{
  "version": 1,
  "asset_id": "1d04841d-ceaf-46f2-a50f-4d0fd1d27411",
  "project_id": "8e4d2e04-d0e9-4cb0-997e-36f9edfa9f56",
  "url": "/__l5e/assets-v1/1d04841d-ceaf-46f2-a50f-4d0fd1d27411/New_door_installation.webp",
  "r2_key": "a/v1/8e4d2e04-d0e9-4cb0-997e-36f9edfa9f56/1d04841d-ceaf-46f2-a50f-4d0fd1d27411/New_door_installation.webp",
  "original_filename": "New_door_installation.webp",
  "size": 196092,
  "content_type": "image/webp",
  "created_at": "2026-08-10T04:00:48Z"
}
